import { Predicate } from "@siteimprove/alfa-predicate";
import { Refinement } from "@siteimprove/alfa-refinement";
import {} from "../input-type.js";
import { hasName } from "./has-name.js";
const { equals, test } = Predicate;
const { and } = Refinement;
export function hasInputType(inputTypeOrPredicate, ...inputTypes) {
    let predicate;
    if (typeof inputTypeOrPredicate === "function") {
        predicate = inputTypeOrPredicate;
    }
    else {
        predicate = equals(inputTypeOrPredicate, ...inputTypes);
    }
    return and(hasName("input"), (element) => test(predicate, element.inputType()));
}
//# sourceMappingURL=has-input-type.js.map